// Sidebar.js
import React from "react";

const Footer = () => {
  return (
    <div className="dashboard-footer">
  <div className="flex-between flex-wrap gap-16">
    <div   style={{color:"black", fontSize:"12px"}}> &copy; Copyright Onezo 2026, All Right Reserved</div>
    <div className="flex-align flex-wrap gap-16">
      <a
        href="https://beingmash.com/"
        className="  hover-text-main-600 hover-text-decoration-underline"
        target="_blank" // Opens link in new tab
        rel="noopener noreferrer" // Security best practice
        style={{color:"black", fontSize:"12px"}}
      >
        Developed by: BeingMash Services Pvt Ltd
      </a>
    </div>
  </div>
</div>

  );
};

export default Footer;
